/** InsCoder WANG.J 2026-05-07 B + Upper sizes filter interactions **/
(function () {
  var SIZE_ORDER = [
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "2x-large",
    "3x-large",
    "4x-large",
    "5x-large",
  ];

  var SIZE_LABELS = {
    "xx-small": "XXS",
    "x-small": "XS",
    small: "S",
    medium: "M",
    large: "L",
    "x-large": "XL",
    "2x-large": "2X",
    "3x-large": "3X",
    "4x-large": "4X",
    "5x-large": "5X",
  };

  function normalizeSizeKey(value) {
    if (!value) return "";

    return value
      .toString()
      .toLowerCase()
      .replace(/\s*\(.*?\)\s*/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/^xx-large$/, "2x-large");
  }

  function getDisplayLabel(key, fallbackLabel) {
    return SIZE_LABELS[key] || fallbackLabel || key.toUpperCase();
  }

  function getGroupOrder(key) {
    var orderIndex = SIZE_ORDER.indexOf(key);
    return orderIndex === -1 ? SIZE_ORDER.length + 1 : orderIndex;
  }

  function getDesktopSizeDisclosure(sectionEl) {
    var sizeSummary = sectionEl.querySelector(
      ".inner-content--desktop [data-faceted-filters] .faceted-filter__summary[data-filter-label='size']"
    );

    return sizeSummary ? sizeSummary.closest("[data-filter-disclosure]") : null;
  }

  function collectSizeGroups(sectionEl) {
    var disclosure = getDesktopSizeDisclosure(sectionEl);
    if (!disclosure) return [];

    var sizeItems = disclosure.querySelectorAll(
      ".faceted-filter__list--size .faceted-filter__list-item"
    );
    var groups = {};

    Array.prototype.forEach.call(sizeItems, function (item) {
      var input = item.querySelector(".input-checkbox-row__checkbox");
      var label = item.querySelector(".faceted-filter__text");
      var key = normalizeSizeKey(
        item.getAttribute("data-size-category") ||
          item.getAttribute("data-original-size-category") ||
          item.getAttribute("data-value") ||
          (label && label.textContent)
      );

      if (!input || !key) return;

      if (!groups[key]) {
        groups[key] = {
          key: key,
          inputs: [],
          active: false,
          available: false,
          fallbackLabel: label ? label.textContent.trim() : "",
        };
      }

      groups[key].inputs.push(input);
      groups[key].active = groups[key].active || input.checked;
      groups[key].available =
        groups[key].available || !input.disabled || input.checked;
    });

    return Object.keys(groups)
      .map(function (key) {
        var group = groups[key];
        group.displayLabel = getDisplayLabel(key, group.fallbackLabel);
        return group;
      })
      .filter(function (group) {
        return group.available;
      })
      .sort(function (groupA, groupB) {
        return getGroupOrder(groupA.key) - getGroupOrder(groupB.key);
      });
  }

  function getSizeGroupsSignature(sizeGroups) {
    return sizeGroups
      .map(function (group) {
        return [
          group.key,
          group.active ? "1" : "0",
          group.available ? "1" : "0",
          group.inputs.length,
        ].join(":");
      })
      .join("|");
  }

  function renderUpperSizes(sectionEl) {
    var panel = sectionEl.querySelector("[data-upper-sizes-panel]");
    var options = sectionEl.querySelector("[data-upper-sizes-options]");
    var sizeGroups = collectSizeGroups(sectionEl);
    var groupsByKey = {};
    var autoShow =
      sectionEl.getAttribute("data-auto-show-upper-sizes") === "true";
    var nextSignature = getSizeGroupsSignature(sizeGroups);
    var fragment;

    if (!panel || !options) return;

    sizeGroups.forEach(function (group) {
      groupsByKey[group.key] = group;
    });
    sectionEl.upperSizeGroups = groupsByKey;

    if (sectionEl.upperSizeRenderSignature === nextSignature) {
      if (sizeGroups.length === 0) {
        panel.hidden = true;
        sectionEl.classList.remove("main-collection-grid--upper-sizes-open");
      } else if (autoShow) {
        panel.hidden = false;
        sectionEl.classList.add("main-collection-grid--upper-sizes-open");
      }
      return;
    }

    sectionEl.upperSizeRenderSignature = nextSignature;
    options.innerHTML = "";
    fragment = document.createDocumentFragment();

    sizeGroups.forEach(function (group) {
      var button = document.createElement("button");
      button.type = "button";
      button.className =
        "filters-upper-sizes__button" +
        (group.active ? " is-active" : "");
      button.setAttribute("data-upper-size-key", group.key);
      button.setAttribute("aria-pressed", group.active ? "true" : "false");
      button.textContent = group.displayLabel;

      fragment.appendChild(button);
    });

    options.appendChild(fragment);

    if (sizeGroups.length === 0) {
      panel.hidden = true;
      if (autoShow) {
        sectionEl.classList.remove("main-collection-grid--upper-sizes-open");
      }
    } else if (autoShow) {
      panel.hidden = false;
      sectionEl.classList.add("main-collection-grid--upper-sizes-open");
    }
  }

  function dispatchImmediateFilterUpdate(input, sectionEl) {
    var form = input && input.closest("form");
    var filtersRoot =
      (input && input.closest("[data-faceted-filters]")) ||
      sectionEl.querySelector(".inner-content--desktop [data-faceted-filters]");
    var searchParams;
    var updateEvent;

    if (!form || !filtersRoot) return false;

    searchParams = new URLSearchParams(new FormData(form)).toString();
    updateEvent = new CustomEvent("filter:update", {
      detail: { searchParams: searchParams },
    });
    filtersRoot.dispatchEvent(updateEvent);
    return true;
  }

  function triggerDefaultSizeFilter(sectionEl, event) {
    event.preventDefault();
    event.stopPropagation();

    var isMobile = window.matchMedia("(max-width: 879px)").matches;

    if (!isMobile) {
      var desktopSizeSummary = sectionEl.querySelector(
        ".faceted-filter__summary[data-filter-label='size']"
      );
      if (desktopSizeSummary) desktopSizeSummary.click();
      return;
    }

    var mobileFilterButton = sectionEl.querySelector(
      ".filters-buttons-mobile__filter-button"
    );
    if (mobileFilterButton) mobileFilterButton.click();

    window.setTimeout(function () {
      var mobileSizeSummary = document.querySelector(
        ".drawer-filter__summary[data-filter-label='size']"
      );
      if (mobileSizeSummary) mobileSizeSummary.click();
    }, 50);
  }

  function toggleUpperSizeGroup(sectionEl, button) {
    var groupKey = button.getAttribute("data-upper-size-key");
    var group =
      sectionEl.upperSizeGroups && sectionEl.upperSizeGroups[groupKey];
    var nextCheckedState;
    var changedInput = null;

    if (!group) return;

    nextCheckedState = !group.active;

    group.inputs.forEach(function (input) {
      if (input.disabled && !input.checked && nextCheckedState) return;

      if (input.checked !== nextCheckedState) {
        input.checked = nextCheckedState;
        changedInput = changedInput || input;
      }
    });

    if (!changedInput) {
      changedInput =
        group.inputs.find(function (input) {
          return !input.disabled || input.checked;
        }) || group.inputs[0];
    }

    if (!changedInput) return;

    if (!dispatchImmediateFilterUpdate(changedInput, sectionEl)) {
      changedInput.dispatchEvent(new Event("input", { bubbles: true }));
      changedInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function setupUpperSizes(sectionEl) {
    var filterSizeBar = sectionEl.querySelector(".filter-size-bar");
    var filterSizeBarLink = filterSizeBar && filterSizeBar.querySelector("a");
    var panel = sectionEl.querySelector("[data-upper-sizes-panel]");
    var desktopFilters = sectionEl.querySelector(
      ".inner-content--desktop [data-faceted-filters]"
    );
    var hasShowUpperSizes =
      filterSizeBar && filterSizeBar.classList.contains("show-upper-sizes");

    if (!filterSizeBar || !filterSizeBarLink || !panel) return;
    if (sectionEl.dataset.upperSizesReady === "true") return;

    sectionEl.dataset.upperSizesReady = "true";
    sectionEl.classList.remove("main-collection-grid--upper-sizes-open");
    panel.hidden = true;

    renderUpperSizes(sectionEl);

    if (!hasShowUpperSizes) {
      filterSizeBarLink.addEventListener("click", function (event) {
        triggerDefaultSizeFilter(sectionEl, event);
      });
      return;
    }

    filterSizeBarLink.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();

      renderUpperSizes(sectionEl);

      if (!panel.querySelector("[data-upper-size-key]")) return;
      sectionEl.classList.add("main-collection-grid--upper-sizes-open");
      panel.hidden = false;
    });

    panel.addEventListener("click", function (event) {
      var button = event.target.closest("[data-upper-size-key]");
      if (!button) return;

      toggleUpperSizeGroup(sectionEl, button);
    });

    if (desktopFilters) {
      var renderTimeoutId = null;
      var observer = new MutationObserver(function () {
        if (renderTimeoutId) window.clearTimeout(renderTimeoutId);

        renderTimeoutId = window.setTimeout(function () {
          renderUpperSizes(sectionEl);
        }, 50);
      });

      observer.observe(desktopFilters, {
        childList: true,
        subtree: true,
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll(".main-collection-grid");

    Array.prototype.forEach.call(sections, function (sectionEl) {
      setupUpperSizes(sectionEl);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
/** InsCoder WANG.J 2026-05-07 E + Upper sizes filter interactions **/